import React from 'react';
import PropTypes from 'prop-types';

function IconCart({ color = '#C2C2C2', size = 24, className }) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.16504 4.16504H6.63925L8.86604 14.3918C8.94315 14.77 9.15045 15.1091 9.45184 15.3502C9.75323 15.5914 10.1296 15.7191 10.5155 15.7114H16.866C17.2519 15.7191 17.6283 15.5914 17.9297 15.3502C18.2311 15.1091 18.4383 14.77 18.5155 14.3918L19.835 7.46399H7.95883M10.349 19.8346C10.8044 19.8346 11.1737 19.4654 11.1737 19.0099C11.1737 18.5544 10.8044 18.1852 10.349 18.1852C9.89346 18.1852 9.52422 18.5544 9.52422 19.0099C9.52422 19.4654 9.89346 19.8346 10.349 19.8346ZM16.9452 19.8346C17.4007 19.8346 17.77 19.4654 17.77 19.0099C17.77 18.5544 17.4007 18.1852 16.9452 18.1852C16.4897 18.1852 16.1205 18.5544 16.1205 19.0099C16.1205 19.4654 16.4897 19.8346 16.9452 19.8346Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

IconCart.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string
}

export default IconCart;
